/**
 * CH Jeans - Performance Loader
 * Estratégia de carregamento diferido para scripts não-críticos
 */

(function () {
  'use strict';

  // ─── 1. LAZY LOADING DE IMAGENS (Intersection Observer) ───────────────────
  // Ativa lazy loading nativo para imagens sem o atributo já definido
  function initLazyImages() {
    const images = document.querySelectorAll('img:not([loading])');
    images.forEach(function (img) {
      // Não aplica lazy em imagens above-the-fold (primeiras 3)
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
    });

    // Intersection Observer para imagens com data-src (lazy manual)
    if ('IntersectionObserver' in window) {
      const lazyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              const img = entry.target;
              if (img.dataset.src) {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
              }
              if (img.dataset.srcset) {
                img.srcset = img.dataset.srcset;
                img.removeAttribute('data-srcset');
              }
              lazyObserver.unobserve(img);
            }
          });
        },
        { rootMargin: '200px 0px' } // começa a carregar 200px antes de entrar na tela
      );

      document.querySelectorAll('img[data-src]').forEach(function (img) {
        lazyObserver.observe(img);
      });
    }
  }

  // ─── 2. LAZY LOADING DE SEÇÕES / COMPONENTES ─────────────────────────────
  // Adia a inicialização de seções fora da viewport
  function initLazySections() {
    if (!('IntersectionObserver' in window)) return;

    const sectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add('section--visible');
            section.dispatchEvent(new CustomEvent('section:lazy-load'));
            sectionObserver.unobserve(section);
          }
        });
      },
      { rootMargin: '150px 0px' }
    );

    // Observa seções abaixo do fold
    const sections = document.querySelectorAll(
      '.shopify-section:not(:first-child):not(:nth-child(2))'
    );
    sections.forEach(function (section) {
      sectionObserver.observe(section);
    });
  }

  // ─── 3. CARREGAMENTO DIFERIDO DE SCRIPTS DE TERCEIROS ────────────────────
  // Scripts de analytics/trackers são carregados após interação do usuário
  // ou após X segundos — não bloqueiam o carregamento inicial

var thirdPartyScripts = [
  {
    id: 'gtm-script',
    src: 'https://www.googletagmanager.com/gtm.js?id=GTM-NTJBWL5R&l=dataLayer',
    callback: function () {
      // Inicializa o dataLayer e dispara o evento gtm.start após carregar
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    }
  }
];

  function loadScript(src, id, callback) {
    if (document.getElementById(id)) return; // evita duplicatas
    var script = document.createElement('script');
    script.src = src;
    script.id = id;
    script.async = true;
    if (callback) script.onload = callback;
    document.body.appendChild(script);
  }

  function loadThirdPartyScripts() {
    thirdPartyScripts.forEach(function (item) {
      loadScript(item.src, item.id, item.callback);
    });
  }

  // ─── 4. DEFER DE IFRAMES (YouTube, Maps, etc.) ───────────────────────────
  function initLazyIframes() {
    if (!('IntersectionObserver' in window)) return;

    const iframeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const iframe = entry.target;
            if (iframe.dataset.src) {
              iframe.src = iframe.dataset.src;
              iframe.removeAttribute('data-src');
            }
            iframeObserver.unobserve(iframe);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    document.querySelectorAll('iframe[data-src]').forEach(function (iframe) {
      iframeObserver.observe(iframe);
    });
  }

  // ─── 5. PRECONNECT DINÂMICO para domínios conhecidos ────────────────────
  function addPreconnects() {
    var domains = [
      'https://www.googletagmanager.com',
      'https://www.google-analytics.com',
      'https://www.clarity.ms',
      'https://cdn.shopify.com',
    ];
    domains.forEach(function (domain) {
      if (!document.querySelector('link[href="' + domain + '"]')) {
        var link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = domain;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
      }
    });
  }

  // ─── 6. ESTRATÉGIA DE ATIVAÇÃO ───────────────────────────────────────────
  // Carrega scripts de terceiros após:
  // (a) primeira interação do usuário, ou
  // (b) após 4 segundos — o que vier primeiro

  var scriptsLoaded = false;

  function triggerLazyLoad() {
    if (scriptsLoaded) return;
    scriptsLoaded = true;

    loadThirdPartyScripts();

    // Remove os event listeners após primeiro disparo
    ['mouseover', 'keydown', 'touchstart', 'scroll'].forEach(function (event) {
      document.removeEventListener(event, triggerLazyLoad);
    });
  }

  // ─── INICIALIZAÇÃO ────────────────────────────────────────────────────────
  function init() {
    addPreconnects();
    initLazyImages();
    initLazySections();
    initLazyIframes();

    // Aguarda interação do usuário para carregar scripts de terceiros
    ['mouseover', 'keydown', 'touchstart', 'scroll'].forEach(function (event) {
      document.addEventListener(event, triggerLazyLoad, { passive: true, once: true });
    });

    // Fallback: carrega após 4 segundos mesmo sem interação
    setTimeout(triggerLazyLoad, 4000);
  }

  // Executa após o DOM estar pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();